// extracted by mini-css-extract-plugin
export default {"ul":"Ul_ul__zi8Jr"};